import { themes } from '@statsbomb/kitbag-components';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const ALL_APP_THEMES = themes.map((theme) => theme.key);

export const THEME_TYPES = { DARK: 'dark', LIGHT: 'light' };

export const DEFAULT_THEME = 'video-dark';
export const DEFAULT_THEME_TYPE = DEFAULT_THEME.includes(THEME_TYPES.DARK)
  ? THEME_TYPES.DARK
  : THEME_TYPES.LIGHT;

const getDarkModeString = (isDarkMode) =>
  isDarkMode ? THEME_TYPES.DARK : THEME_TYPES.LIGHT;

export const themeAtom = atomWithStorage(DEFAULT_THEME);
themeAtom.debugLabel = 'theme';

export const isDarkModeAtom = atomWithStorage(
  'isDarkMode',
  DEFAULT_THEME.includes(THEME_TYPES.DARK),
);
isDarkModeAtom.debugLabel = 'isDarkMode';

export const fullThemeNameAtom = atom(
  (get) => get(themeAtom),
  (_, set, newTheme) => {
    set(themeAtom, newTheme);
    set(isDarkModeAtom, newTheme.includes(THEME_TYPES.DARK));
  },
);

export const toggleDarkModeAtom = atom(
  (get) => getDarkModeString(get(isDarkModeAtom)),
  (get, set) => {
    set(
      themeAtom,
      (get(themeAtom) || DEFAULT_THEME).replace(
        getDarkModeString(get(isDarkModeAtom)),
        getDarkModeString(!get(isDarkModeAtom)),
      ),
    );
    set(isDarkModeAtom, !get(isDarkModeAtom));
  },
);

export default { themeAtom };
